import api from '.'

export function gerar(ano) {
  return api.get(`/relatorio/${ano}`)
}